"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { ActiveDropState } from "@/types/dropInteractionTypes";
import BrainContent from "../content/BrainContent";
import Notifications from "./index";
const NotificationsContainer: React.FC = () => {
  const $ = _c(6);
  const [activeDrop, setActiveDrop] = useState(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setActiveDrop(null);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const onCancelReplyQuote = t0;
  let t1;
  if ($[1] !== activeDrop) {
    t1 = <Notifications activeDrop={activeDrop} setActiveDrop={setActiveDrop} />;
    $[1] = activeDrop;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== activeDrop || $[4] !== t1) {
    t2 = <BrainContent activeDrop={activeDrop} onCancelReplyQuote={onCancelReplyQuote} showPinnedWaves={false}>{t1}</BrainContent>;
    $[3] = activeDrop;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export default NotificationsContainer;